import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import CDNImage from "@inspire/ui/general/CDNImage";
import "./PisteGauge.scss";
function getAngle(score) {
    var delta = 20;
    return score / 100 * 180 + (-2 * score / 100 + 1) * delta;
}
var PisteGauge = function(param) {
    var score = param.score;
    var ref = useState(getAngle(0)), angle = ref[0], setAngle = ref[1];
    useEffect(function() {
        var timer = setTimeout(function() {
            setAngle(getAngle(score));
        }, 500);
        return function() {
            return clearTimeout(timer);
        };
    });
    return /*#__PURE__*/ _jsxs("div", {
        className: "sc-gauge",
        alt: "".concat(score, "%"),
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "sc-outline"
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "sc-background",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "sc-percentage",
                        style: {
                            transform: "rotate(".concat(angle, "deg)")
                        }
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "sc-mask"
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "sc-left-mask"
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "sc-right-mask"
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "sc-needle",
                style: {
                    transform: "rotate(".concat(angle, "deg)")
                }
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "sc-emojis",
                children: [
                    /*#__PURE__*/ _jsx("span", {
                        className: "sc-min",
                        children: /*#__PURE__*/ _jsx(CDNImage, {
                            src: "/twemoji-13.1.0/1f641.png",
                            alt: "pas du tout",
                            height: "22px",
                            width: "22px",
                            border: "1px black solid"
                        })
                    }),
                    /*#__PURE__*/ _jsx("span", {
                        className: "sc-max",
                        children: /*#__PURE__*/ _jsx(CDNImage, {
                            src: "/twemoji-13.1.0/1f60d.png",
                            alt: "beaucoup",
                            height: "22px",
                            width: "22px"
                        })
                    })
                ]
            })
        ]
    });
};
PisteGauge.propTypes = {
    score: PropTypes.number
};
export default PisteGauge;
